import React, { useState } from "react";
import {
  worldbg,
  world1,
  world2,
  world3,
  world4,
  world5,
  world6,
  roboteye,
  worldframe,
  arrow2,
} from "../Assets";

const World = () => {
  const [offset, setOffset] = useState(0);
  const images = [world1, world2, world3, world4, world5, world6];
  const maxOffset = images.length - 1;

  const handleNext = () => {
    setOffset((prev) => (prev < maxOffset ? prev + 1 : 0));
  };

  return (
    <div
      className="w-full  bg-cover bg-center flex flex-col lg:flex-row items-center justify-center px-10 py-32"
      style={{ backgroundImage: `url(${worldbg})` }}
    >
      <div className="max-w-7xl w-full lg:flex flex-col lg:flex-row gap-10 lg:gap-20 items-center lg:items-start">
        {/* Left Column */}
        <div className="flex-1 flex flex-col justify-center text-white text-center lg:text-left">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold leading-tight uppercase">
            The World of
            <br />
            Molundra
          </h1>
          <hr className="my-6 border-white w-24 mx-auto lg:mx-0" />
          <p className="text-sm sm:text-base mb-8 max-w-md leading-loose tracking-wide mx-auto lg:mx-0">
            In the shadows of a fractured sky, forgotten code stirs beneath the
            ruins. Ancient machines lie dormant, whispering secrets in a
            language long lost.Molundra, once silenced, pulses again with unseen
            power. Those who awaken it must choose: rebirth or ruin.
          </p>
          <img
            src={roboteye}
            alt="Robot Eye"
            className="w-32 sm:w-40 md:w-48 mx-auto lg:mx-0"
          />
        </div>

        {/* Right Column */}
        <div className="flex-1 relative flex items-center justify-center -ml-20 py-10">
          <div className="relative w-full max-w-[60vw] sm:max-w-[22rem] md:max-w-[26rem] h-[60vw] sm:h-[28rem] md:h-[32rem]">
            {images.map((imgSrc, i) => {
              const index = (i + offset) % images.length;
              const zIndex = images.length - i;
              const leftOffset = i * 20;
              return (
                <React.Fragment key={i}>
                  <img
                    src={images[index]}
                    alt={`World stack ${i}`}
                    className="absolute top-0 left-0 w-full h-full object-contain rounded-lg shadow-lg transition-all duration-500 ease-in-out"
                    style={{
                      transform: `translateX(${leftOffset}px) scale(${
                        1 - i * 0.05
                      })`,
                      zIndex: zIndex,
                    }}
                  />
                </React.Fragment>
              );
            })}
            <div className="absolute top-0 left-0 w-full h-full z-50 pointer-events-none">
              <img
                src={worldframe}
                alt="World Frame"
                className="w-full h-full object-contain scale-105"
              />
            </div>
          </div>
          <button
            onClick={handleNext}
            className="absolute -right-10 top-1/2 -translate-y-1/2 z-50"
            aria-label="Next"
          >
            <img
              src={arrow2}
              alt="Next"
              className="w-12 h-12 sm:w-20 sm:h-20 md:w-24 md:h-24"
            />
          </button>
        </div>
      </div>
    </div>
  );
};

export default World;
